<template>
    <div>
      <HeaderComponent />
      <main class="container mx-auto px-4 py-6 md:py-12 lg:py-16" style="min-height: 46.5rem;">
        <div v-if="selectedForm">
            <DemoForm  :leadType="selectedForm" :pageTitle="pageTitle" :pageDescription:="pageDescription" :currentUrl:="currentUrl"/>
        </div>
        <div v-else>
            <h1 class="text-3xl font-bold mb-8 text-center">Free Demo</h1>
            <section class="grid md:grid-cols-2 lg:grid-cols-32 gap-8">
            <article class="bg-gray-200 shadow rounded-lg p-14 transition duration-300 ease-in-out transform hover:-translate-y-1 hover:shadow-lg flex flex-col justify-between">
                <div>
                <h2 class="text-xl font-semibold mb-4 text-center">E-Signature Contract Demo</h2>
                <p class="mb-4 text-center">Explore our E-Signature solution to streamline your document signing process and improve workflow efficiency.</p>
                </div>
                <div class="text-center">
                    <router-link to="/demo/e-signature" @click="showForm('contract')" class="inline-block bg-blue-500 hover:bg-blue-600 text-white font-bold py-3 px-4 rounded transition duration-300 ease-in-out transform hover:-translate-y-1">
                        Try E-signature Contract Demo
                    </router-link>
                </div>
            </article>
            <article class="bg-gray-200 shadow rounded-lg p-14 transition duration-300 ease-in-out transform hover:-translate-y-1 hover:shadow-lg flex flex-col justify-between">
                <div>
                <h2 class="text-xl font-semibold mb-4 text-center">Survey Demo</h2>
                <p class="mb-4 text-center">Create and analyze surveys effortlessly to gain valuable insights from your audience.</p>
                </div>
                <div class="text-center">
                    <router-link to="/demo/survey" @click="showForm('survey')" class="inline-block bg-blue-500 hover:bg-blue-600 text-white font-bold py-3 px-4 rounded transition duration-300 ease-in-out transform hover:-translate-y-1">
                        Try Survey Demo
                    </router-link>
                </div>
            </article>
            </section>
        </div>
      </main>
      <FooterComponent />
    </div>
    </template>
    
    <script setup>
    import { ref, computed, watch } from 'vue';
    import {useCommonHead} from '../composables/useCommonHead';
    import HeaderComponent from "../components/Header.vue";
    import FooterComponent from "../components/Footer.vue";
    import DemoForm from '../components/DemoForm.vue';

    const selectedForm = ref(null);

    const pageTitle = computed(() => {
        if (selectedForm.value === 'contract') return 'E-Signature Contract Demo';
        if (selectedForm.value === 'survey') return 'Survey Demo';
        return 'Salesforce Free Demo';
    });

    const pageDescription = computed(() => {
        if (selectedForm.value === 'contract') {
            return 'Experience our E-Signature Contract Demo to streamline your document signing process and improve workflow efficiency.';
        }
        if (selectedForm.value === 'survey') {
            return 'Try our Survey Demo to create and analyze surveys effortlessly, gaining valuable insights from your audience.';
        }
        return 'Discover E-Signature and Survey Demos to enhance your Salesforce experience and streamline your processes.';
    });

    const currentUrl = computed(() => {
        if (selectedForm.value === 'contract') return '/demo/e-signature';
        if (selectedForm.value === 'survey') return '/demo/survey';
        return '/demo';
    });

    const showForm = (leadType) => {
        selectedForm.value = leadType;
    };
    
    watch([pageTitle, pageDescription, currentUrl], () => {
        useCommonHead(pageTitle.value, pageDescription.value, currentUrl.value);
    });

    // Initial call to set the head
    useCommonHead(pageTitle.value, pageDescription.value, currentUrl.value);
    </script>